import { Button, EmptyState, NavigationCard, Skeleton, Stack, Tag } from '@all-manager/design-system-v2';
import AuthLayout from '../../../../layout/AuthLayout/AuthLayout';
import { useSpaceSelectionPage } from './useSpaceSelectionPage';

const SKELETON_CARDS = [0, 1, 2];
const SKELETON_CARD_HEIGHT = 64;

export function SpaceSelectionPage() {
  const hook = useSpaceSelectionPage();

  return (
    <AuthLayout
      title="Sélectionner un espace"
      description="Choisissez la copropriété à consulter."
      width="wide"
      surface="plain"
    >
      {hook.isLoading ? (
        <Stack spacing={2} aria-busy>
          {SKELETON_CARDS.map((card) => (
            <Skeleton key={card} variant="rounded" height={SKELETON_CARD_HEIGHT} />
          ))}
        </Stack>
      ) : hook.spaces.length === 0 ? (
        <EmptyState
          title="Aucun espace disponible"
          subtitle="Votre compte n'est rattaché à aucune copropriété. Demandez à l'administrateur de votre copropriété de vous inviter."
          action={<Button variant="text" onClick={hook.handleSignOut}>Se déconnecter</Button>}
        />
      ) : (
        <Stack spacing={2}>
          {hook.spaces.map((space) => (
            <NavigationCard
              key={space.id}
              title={space.name}
              href={space.href}
              onClick={space.handleClick}
              tags={<Tag color="default" label={space.roleLabel} />}
            />
          ))}
        </Stack>
      )}
    </AuthLayout>
  );
}
